<div class="flex justify-between items-center flex-wrap h-1/2 bg-[#F8F9FA]">
  <!-- * LEFT SIDE -->
  <div class="flex items-center flex-wrap">
    <!-- * PRODUCT SELECTOR -->
    @if (feUtil.applications && feUtil.applications.length > 1) {
    <div class="m-0 p-3 px-4 place-items-center flex" nz-popover [nzPopoverContent]="productTemplate"
      nzPopoverPlacement="bottomLeft" (click)="productVisible = !productVisible"
      [(nzPopoverVisible)]="productVisible" nzPopoverTrigger="click" nzType="default">
      <i nz-icon nzType="product" nzTheme="outline" class="text-primary text-xl cursor-pointer"></i>
      <ng-template #productTemplate>
        <div class="py-2.5 px-2 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
          <nz-row class="p-2 bg-primary/5 m-2 border rounded-lg" [nzGutter]="[16,16]">
            <ng-container *ngFor="let application of feUtil.applications">
              @let config = getApplicationConfig(application.name);
              <nz-col *ngIf="!application.allowedOrigin || application.allowedOrigin.includes(feUtil.getOriginEnv)" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
                <button type="button" role="group" aria-label="Application" (click)="config.active ? handleProductClick(application.id): null; productVisible = false;"
                  [ngClass]="['flex items-center gap-2 p-2 rounded-lg border shadow-sm transition-all bg-white group w-full focus:ring-2 focus:ring-offset-2 text-sm', selectedApplication === application.id ? 'border-primary ring-1 ring-primary' : 'border-gray-200 hover:border-primary hover:shadow-lg', !config.active ? 'opacity-60 pointer-events-none select-none cursor-not-allowed grayscale' : 'cursor-pointer hover:scale-[1.03] active:scale-100']"
                  [attr.aria-disabled]="!config.active" [attr.tabindex]="config.active ? 0 : -1"
                  [attr.title]="config.active ? 'Switch to ' + config.title : config.title + ' (Coming soon)'">
                  <div class="flex-shrink-0 flex items-center justify-center rounded-xl transition-colors duration-200"
                    [ngClass]="selectedApplication === application.id ? 'bg-primary/20' : 'bg-gray-50'" [style.width.px]="26"
                    [style.height.px]="26">
                    <i nz-icon [nzType]="config.icon" class="transition-colors duration-200"
                      [ngClass]="[selectedApplication === application.id ? 'text-primary' : 'text-gray-400 group-hover:text-primary border-primary', 'text-sm']">
                    </i>
                  </div>
                  <div class="flex flex-col text-left min-w-0">
                    <span class="font-semibold truncate text-[13px]"
                      [ngClass]="selectedApplication === application.id ? 'text-primary' : 'text-gray-800'">{{ config.title }}</span>
                    <span class="text-xs text-gray-500 truncate">{{ config.description }}</span>
                    <span *ngIf="!config.active && config.title == 'Manufacturing'" class="inline-block mt-1 px-2 py-0.5 text-xs text-yellow-800 bg-yellow-100 rounded-full font-medium">Coming soon</span>
                  </div>
                  <div *ngIf="selectedApplication === application.id" class="ml-auto">
                    <i nz-icon nzType="check-circle" nzTheme="twotone" class="text-green-500 text-lg"></i>
                  </div>
                </button>
              </nz-col>
            </ng-container>
          </nz-row>
        </div>
      </ng-template>
    </div>
    }
    <!-- * LOGO -->
    <div [class]="feUtil.applications && feUtil.applications.length > 1 ? '' : 'ml-6'" *ngIf="feUtil.getRegion == 'us' || feUtil.getRegion == 'local'; else hezkyTextLogo">
      <img nz-image src="assets/svg/hezky.svg" alt="Hezky tech" class="logo" draggable="false" width="100px"
        sm:width="100px">
    </div>
    <ng-template #hezkyTextLogo>
      <div class="flex items-center bg-primary px-3 py-3 relative">
        @if (selectedApplication === 2) {
        <span class="text-lg font-semibold text-white hover:text-white/90 transition-colors font-lato">
          Hezky {{ selectedApplicationName | titlecase }}
        </span>
        } @else {
        <span
          class="text-xl font-semibold text-white hover:text-white/90 transition-colors w-[125px] text-center font-lato">
          Hezky <span class="text-xl font-[300] text-white hover:text-white/90 transition-colors">Tech</span>
        </span>
        }
        <div
          class="absolute -right-2 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[8px] border-t-transparent border-l-[8px] border-l-primary border-b-[8px] border-b-transparent">
        </div>
      </div>
    </ng-template>

    <!-- * NAVIGATION -->
    <ul nz-menu nzMode="horizontal" class="hidden desktop:block border-none bg-[#F8F9FA]">
      <ng-template #recursiveMenu let-items let:isRoot="isRoot">
        @for (item of items; track item.label) {
          @if (item.type === 'link') {
            <li nz-menu-item
              [class.ant-menu-item-selected]="item.routerLink ? feUtil.router.url.includes(item.routerLink) : false"
              *ngIf="item.permission?.accessRight ? feUtil.roleService.hasAccess(item.permission.accessRight) : true">
              <a [routerLink]="[item.routerLink]" [state]="item?.state || {}" [queryParams]="item?.queryParams || {}"
                aria-label="Go to {{ item.label }}" [title]="item.label">
                {{ item.label }}
              </a>
            </li>
          } @else if (item.type === 'submenu') {
            <!-- Submenu open to bottomLeft, nested-submenu handled differently below -->
            <li nz-submenu
                nzPlacement="bottomLeft"
                [nzTitle]="submenuTpl"
                *ngIf="!item.permission?.accessRight || feUtil.roleService.hasAccess(item.permission.accessRight)">
              <ul>
                @for (child of item.children ?? []; track child.label) {
                  @if (child.type === 'submenu') {
                    <!-- Nested submenu; opens to right -->
                    <li nz-submenu
                        nzPlacement="bottomLeft"
                        [nzTitle]="nestedSubmenuTpl"
                        *ngIf="!child.permission?.accessRight || feUtil.roleService.hasAccess(child.permission.accessRight)">
                      <ul>
                        @for (grandchild of child.children ?? []; track grandchild.label) {
                          @if (grandchild.type === 'submenu') {
                            <!-- Third level submenu, also open to right -->
                            <li nz-submenu
                                [nzTitle]="thirdSubmenuTpl"
                                *ngIf="!grandchild.permission?.accessRight || feUtil.roleService.hasAccess(grandchild.permission.accessRight)">
                              <ul>
                                <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: grandchild.children, isRoot: false }"></ng-container>
                              </ul>
                              <ng-template #thirdSubmenuTpl>
                                <span class="hover:text-blue-500 ml-1.5">{{ grandchild.label }}</span>
                              </ng-template>
                            </li>
                          } @else {
                            <li nz-menu-item
                                [class.ant-menu-item-selected]="grandchild.routerLink ? feUtil.router.url.includes(grandchild.routerLink) : false"
                                *ngIf="!grandchild.permission?.accessRight || feUtil.roleService.hasAccess(grandchild.permission.accessRight)">
                              <a [routerLink]="[grandchild.routerLink]" [state]="grandchild?.state || {}"
                                 [queryParams]="grandchild?.queryParams || {}"
                                 aria-label="Go to {{ grandchild.label }}"
                                 [title]="grandchild.label">
                                {{ grandchild.label }}
                              </a>
                            </li>
                          }
                        }
                      </ul>
                      <ng-template #nestedSubmenuTpl>
                        <span class="hover:text-blue-500 ml-1.5">{{ child.label }}</span>
                      </ng-template>
                    </li>
                  } @else {
                    <li nz-menu-item
                        [class.ant-menu-item-selected]="child.routerLink ? feUtil.router.url.includes(child.routerLink) : false"
                        *ngIf="!child.permission?.accessRight || feUtil.roleService.hasAccess(child.permission.accessRight)">
                      <a [routerLink]="[child.routerLink]" [state]="child?.state || {}"
                         [queryParams]="child?.queryParams || {}"
                         aria-label="Go to {{ child.label }}"
                         [title]="child.label">
                        {{ child.label }}
                      </a>
                    </li>
                  }
                }
              </ul>
              <ng-template #submenuTpl>
                <span class="hover:text-blue-500">{{ item.label }}</span>
                <i nz-icon nzType="caret-down" style="font-size: 12px;" class="ml-1" nzTheme="outline"></i>
              </ng-template>
            </li>
          }
        }
      </ng-template>
      <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: routeData, isRoot: true }"></ng-container>
    </ul>
  </div>
  <!-- * RIGHT SIDE -->
  <div class="flex items-center gap-2">
    <div class="hidden phone:flex mini:flex tablet:flex items-center gap-2">
      <nz-badge [nzDot]="beUtil.notificationSvc.unreadCount > 0 ? true : false">
        <button nz-button nzType="default" nz-popover nzPopoverPlacement="bottomRight" [nzPopoverTitle]="notificationHeader"
          (click)="isNotification = !isNotification" nzPopoverTrigger="click" [nzPopoverContent]="notificationContent"
          [(nzPopoverVisible)]="isNotification" class="border-[#D9D9D9] cursor-pointer">
          <i nz-icon nzType="hezky:Notification" class="hover:text-primary text-base"></i>
        </button>
      </nz-badge>
      <button nz-button nz-popover [(nzPopoverVisible)]="locationVisible" nzPopoverTrigger="click" nzType="default" 
        [nzPopoverContent]="contentTemplate" (click)="locationVisible = !locationVisible"
        nzPopoverPlacement="bottomRight" class="border-[#D9D9D9] cursor-pointer">
        <i nz-icon [nzType]="'hezky:Location'" class="text-[#252524] hover:text-primary text-lg"></i>
      </button>
      <ng-template #contentTemplate>
          <app-location-tree [type]="'view-search'" (nodeSelectEvent)="locationVisible = false" />
      </ng-template>
    </div>
    <ul nz-menu nzMode="horizontal" class="border-none bg-[#F8F9FA] hidden tablet:flex">
      <li nz-submenu [nzTitle]="profileDropdown" nzPlacement="bottomRight" aria-label="Profile">
        <ul class="rounded-md shadow-md">
          <li nz-menu-item [routerLink]="['/account-settings']">
            <i class="mr-2" nz-icon nzType="user" nzTheme="outline"></i> Account Settings
          </li>
          <li nz-menu-item [routerLink]="['/get-support']">
            <i class="mr-2 rotate-180" nz-icon nzType="phone" nzTheme="outline"></i> Get Support
          </li>
          <li nz-menu-item routerLink="/auth/login" (click)="authorizationSvc.onLogout()">
            <i class="mr-2" nz-icon [nzType]="'hezky:Sign_Out'" nzTheme="outline"></i> Logout
          </li>
        </ul>
      </li>
    </ul>
    <ng-template #profileDropdown>
      <span class="text-sm font-medium text-gray-600">{{ feUtil['user_data']['first_name'] }}</span>
      <i nz-icon nzType="caret-down" style="font-size: 12px;" class="ml-1" nzTheme="outline"></i>
    </ng-template>
    <div class="items-center px-2 desktop:hidden tablet:flex phone:flex mini:flex">
      <i nz-icon nzType="menu" nzTheme="outline" class="text-xl text-gray-700" (click)="drawer = !drawer"
        aria-label="Menu" role="button" title="Menu"></i>
    </div>
  </div>
</div>

<!-- * MOBILE & TABLET MENU -->
<nz-drawer [nzWidth]="240" [nzClosable]="true" [nzVisible]="drawer" nzMaskClosable="true" (nzOnClose)="drawer = false"
  nzPlacement="left" [nzTitle]="drawerTitle" [nzBodyStyle]="{ padding: '0' }">
  <ng-template #drawerTitle>
    <div class="flex items-center">
      <img src="/assets/svg/hezky_logo_V2.svg" style="-webkit-user-drag: none;" class="w-5 mr-2" alt="hezkytech"
        loading="eager" decoding="sync" crossorigin="anonymous">
      <span class="font-semibold" nzEllipsis>{{ 'Hey, ' + feUtil['user_data']['first_name']}}</span>
    </div>
  </ng-template>
  <ng-container *nzDrawerContent>
    <div class="p-2">
      <ul nz-menu nzMode="inline" class="border-none w-full" >
        <ng-template #recursiveMobileMenu let-items let:isRoot="isRoot">
          @for (item of items; track item.label) {
            @if (item.type === 'link') {
              <li nz-menu-item
                  *ngIf="item.permission?.accessRight ? feUtil.roleService.hasAccess(item.permission.accessRight) : true"
                  [class.ant-menu-item-selected]="item.routerLink ? feUtil.router.url.includes(item.routerLink) : false"
                  (click)="drawer = false">
                <a [routerLink]="[item.routerLink]"
                  [queryParams]="item?.queryParams || {}"
                  aria-label="Go to {{ item.label }}"
                  [title]="item.label">
                  {{ item.label }}
                </a>
              </li>
            } @else if (item.type === 'submenu') {
              <li nz-submenu
                  [nzTitle]="mobileSubmenuTpl"
                  *ngIf="!item.permission?.accessRight || feUtil.roleService.hasAccess(item.permission.accessRight)">
                <ul>
                  <ng-container *ngTemplateOutlet="recursiveMobileMenu; context:{ $implicit: item.children ?? [], isRoot: false }"></ng-container>
                </ul>
                <ng-template #mobileSubmenuTpl>
                  <span class="hover:text-blue-500">{{ item.label }}</span>
                </ng-template>
              </li>
            }
          }
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveMobileMenu; context:{ $implicit: routeData, isRoot: true }"></ng-container>
        <li nz-submenu nzTitle="Profile" nzPlacement="bottomRight" class="tablet:hidden" aria-label="Profile">
          <ul class="rounded-md shadow-md">
            <li nz-menu-item [routerLink]="['/account-settings']">
              <i class="mr-2" nz-icon nzType="user" nzTheme="outline"></i> Account Settings
            </li>
            <li nz-menu-item [routerLink]="['/get-support']">
              <i class="mr-2 rotate-180" nz-icon nzType="phone" nzTheme="outline"></i> Get Support
            </li>
            <li nz-menu-item routerLink="/auth/login" class="text-danger" (click)="authorizationSvc.onLogout()">
              <i class="mr-2" nz-icon [nzType]="'hezky:Sign_Out'" nzTheme="outline"></i> Logout
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </ng-container>
</nz-drawer>

<ng-template #notificationHeader>
  <div class="flex items-baseline justify-between py-2">
    <h3 class="text-sm">Notifications</h3>
    <div class="flex justify-end">
      <button nz-button nzType="link" class="text-sm mr-1" (click)="notification.markAllAsRead()">Mark all as
        read</button>
      <button nz-button nzType="link" (click)="isNotification = false">
        <i nz-icon nzType="close" class="text-sm"></i>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #notificationContent>
  <app-notification #notification (markRead)="isNotification = false"></app-notification>
</ng-template>